import React, { useState, useEffect } from "react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <div
          onClick={scrollToTop}
          onKeyDown={(e) => {
            if (e.key === 'Enter') scrollToTop();
          }}
          className="scroll-to-top-button"
          title="Scroll to Top"
          aria-label="Scroll to top of page"
        >
          <i className="fa fa-arrow-circle-up fa-3x"></i>
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;